
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/Form';

/**
 * @class NCForm
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCForm
 * @label 表单
 *
 */
class NCForm extends Component {

    static propTypes = {
        /**
         * @title 区域编码
         * @description 区域编码
         */
        moduleId: PropTypes.string.isRequired,
         /**
         * @title 是否可见
         * @description 是否可见
         */
          visible: PropTypes.bool,
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderComp() {
        const configProps = getPropsFromMeta(this.props, NCForm.getCompMeta());
        const { form, moduleId, meta, config = {} } = this.props;
        const { createForm } = form;
        let metaData = meta.getMeta();
        let ret = null;
        let formMetaData = metaData[moduleId];
        if (formMetaData) {
            ret = (
                <div className="lc-drop-area nc-bill-form-area">
                    {createForm(moduleId, Object.assign(configProps, config))}
                </div>
            )
        } else {
            ret = (
                <div>没有绑定模板数据</div>
            )
        }
        return ret;

    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCForm;
